import { useQuery } from '@apollo/client';

import useCompanyContext from 'common/hooks/useCompanyContext';
import { throwIfErrorPresent } from 'features/Onboarding/utils';

import { isPrimaryApplicantQuery } from './graphql';
import { IsPrimaryApplicantHook, IsPrimaryApplicantQueryData } from './types';

const useIsPrimaryApplicant: IsPrimaryApplicantHook = (options = {}) => {
  const { companyProfileId } = useCompanyContext();
  const { treatMissingCompanyUserAsPrimaryApplicant = false } = options;
  const { data, error, loading } = useQuery<IsPrimaryApplicantQueryData>(
    isPrimaryApplicantQuery,
    {
      // During the onboarding, before you create a company,
      // you don't have a company user, so we want to make sure
      // this is retrieved directly from the network
      // rather than relying on a possibly outdated cache
      fetchPolicy: 'network-only',
      skip: !companyProfileId,
      variables: {
        companyProfileId,
      },
    },
  );
  throwIfErrorPresent(error);
  if (loading === true) {
    return { isPrimaryApplicant: undefined, loading };
  }
  // Return the retrieved field if it exists,
  // or the value of treatMissingCompanyUserAsPrimaryApplicant
  // (if treatMissingCompanyUserAsPrimaryApplicant is true,
  // we want to return true; false otherwise)
  return {
    isPrimaryApplicant:
      data?.viewer.companyUser.isPrimaryApplicant ??
      treatMissingCompanyUserAsPrimaryApplicant,
    loading,
  };
};

export default useIsPrimaryApplicant;
